<template>
  <div class="video-dialogue-parent">
    <InteractiveDialogue :dialogue="dialogue" :videoOptions="videoOptions"/>
  </div>
</template>

<script>
// @ is an alias to /src
import InteractiveDialogue from "@/components/InteractiveDialogue.vue";
import Dialogues from "@/views/dialogues.json";

export default {
  name: "home",
  components: {
    InteractiveDialogue
  },
  computed: {
    dialogue() {
      return Dialogues[this.$route.params.id];
    },
    videoOptions() {
      // let baseSRC = 'http://localhost:8080//kyrgyz-language-dialogues/'
      let baseSRC =
        "https://static-assets.linguaworks.com/kyrgyz-language-dialogues/";
      return {
        sources: [
          {
            src: baseSRC + this.$route.params.id + ".mp4",
            type: "video/mp4"
          }
        ],
        fluid: true
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.video-dialogue-parent {
  height: 100%;
  position: relative;
}
.tool-title {
  color: #297050;
  font-weight: bold;
}
</style>
